import styled from 'styled-components/macro'
import { BaseColor, spacing, themeColor } from '@unbounded/unbounded-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Placeholder = styled.div`
  min-height: ${spacing(10)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeColor(BaseColor.shade_50)};
`
